module.exports = __webpack_public_path__ + "static/media/robot.1a9ae223.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/order/robot.png
// module id = 403
// module chunks = 0